export default "__VITE_ASSET__WZl8dvCf__"